<div class="modal-container" (click)="onBackdropClick($event)">
  <div class="modal-content">
    <div class="modal-header">
      <h3>Test del {{ assessment.savedAt | date: 'dd/MM/yyyy HH:mm' }}</h3>
      <button type="button" class="modal-close" (click)="closed.emit()" aria-label="Chiudi">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-layout">
    <aside class="modal-summary" aria-label="Riepilogo del test">
      <div class="score-chip total-chip">
        <span class="detail-label">Totale</span>
        <span class="area-score">{{ formatScore(assessment.total) }}</span>
      </div>
      <div class="score-chip" [ngClass]="toneClass(area.grade)" *ngFor="let area of summaryAreas">
        <span class="detail-label area-label">
          <span class="i-icon-small area-icon" [ngClass]="areaIcon(area.area)" aria-hidden="true"></span>
          {{ areaLabel(area.area) }}
        </span>
        <div class="score-chip-bottom">
          <span class="area-score">{{ formatScore(area.score) }}</span>
          <span class="grade-chip" [ngClass]="gradeClass(area.grade)" [title]="gradeLabel(area.grade)">{{ area.grade }}</span>
        </div>
      </div>
      <div class="score-chip recognition-chip" *ngIf="assessment.status">
        <span class="detail-label">Caso</span>
        <span class="area-score">{{ caseStatusLabel(assessment.status) }}</span>
      </div>
    </aside>

    <div class="modal-body">
      <div class="state-message" *ngIf="detailLoading">
        <i class="bi bi-hourglass-split" aria-hidden="true"></i> Caricamento delle risposte...
      </div>

      <div class="warning-banner" role="alert" *ngIf="!detailLoading && detailFailed">
        <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
        <p>
          Non è stato possibile caricare le risposte di questo test.
          <button type="button" class="link-btn" (click)="retryDetail()">Riprova</button>
        </p>
      </div>

      <section class="answers-section" *ngFor="let section of sections">
        <h4><span class="section-icon i-icon-small" [ngClass]="section.icon" aria-hidden="true"></span>{{ section.title }}</h4>
        <div class="answers-list">
          <div class="answer-item" *ngFor="let answer of section.answers" [class.unanswered]="answer.unanswered">
            <p class="answer-question">{{ answer.text }}</p>
            <p class="answer-value">{{ answer.selectedLabel }}</p>
          </div>
        </div>
      </section>

      <section class="notes-section" *ngIf="detail && !detailLoading && !detailFailed">
        <h4><span class="section-icon i-icon-small i-document" aria-hidden="true"></span>Commento e piano</h4>

        <div class="notes-field" role="group" aria-labelledby="longevity-comment-label">
          <p class="notes-label" id="longevity-comment-label">Commento</p>
          <app-text-editor-wrapper [controlText]="commentControl" [editorModules]="editorModules"></app-text-editor-wrapper>
        </div>

        <div class="notes-field" role="group" aria-labelledby="longevity-plan-label">
          <p class="notes-label" id="longevity-plan-label">Piano</p>
          <app-text-editor-wrapper [controlText]="planControl" [editorModules]="editorModules"></app-text-editor-wrapper>
        </div>

        <div class="notes-actions">
          <span class="notes-status notes-status-ok" role="status" *ngIf="notesSaved && !notesDirty">
            <i class="bi bi-check-circle-fill" aria-hidden="true"></i> Salvato
          </span>
          <span class="notes-status notes-status-error" role="alert" *ngIf="notesError">
            <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i> {{ notesError }}
          </span>
          <button type="button" class="btn-save" [disabled]="notesSaving || !notesDirty" (click)="saveNotes()">
            {{ notesSaving ? 'Salvataggio...' : 'Salva' }}
          </button>
        </div>
      </section>
    </div>
    </div>
  </div>
</div>
